import React, { useState, useEffect } from 'react';
import { StyleSheet } from 'react-native';

interface VoidOrderConfirmationPopupProps {
    onClose: () => void;
    onConfirm: () => void;
}


const VoidOrderConfirmationPopup: React.FC<VoidOrderConfirmationPopupProps> = ({ onClose, onConfirm }) => {
    const handleSaveChanges = () => {
        onConfirm();
    };

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const styles = StyleSheet.create({
        popup: {
            width: windowSize.width > 900 ?  windowSize.width * 0.40 :  windowSize.width * 0.9,
            backgroundColor: '#fff',
            position: 'fixed',
            zIndex: 8000,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
        input: {
            shadowOpacity: 0,
            borderRadius: 8,
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: '#D0D5DD',
            height: 35
        }
    });
    
    return (
        <div style={styles.popup} className='popup-shadow ds-pop ds-pop--center'>
            <div className='d-flex px-3 pt-3 justify-content-between'>
                <h5>Confirmation</h5>
            </div>
            <div className='px-3 pb-3 d-flex flex-column'>
                <small className='mt-3'>
                    This order is <b>Paid</b>. Voiding this order will cancel the payment made and a new payment must be submitted.
                </small>
                <div className='d-flex mt-4 align-items-center justify-content-center' style={{ gap: '10px', flexWrap: 'nowrap' }}>
                    <button className='blue-outline-btn align-items-center d-flex w-100' onClick={onClose} style={{ borderRadius: 8 }}>
                        Cancel
                    </button>
                    <button className='blue-filled-btn align-items-center d-flex w-100' onClick={handleSaveChanges} style={{ borderRadius: 8 }}>
                        Continue
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VoidOrderConfirmationPopup;

